import * as React from 'react';
import {
  GoogleMap,
  DirectionsService,
  DirectionsRenderer,
} from '@react-google-maps/api';
import {
  GOOGLE_MAP_ID,
  useGoogleMapsLoader,
} from 'hooks/api/google';
import { cn } from 'lib/utils';

import { useMapHelper } from './hooks';

type Props = React.HTMLAttributes<HTMLDivElement>

export const TransportRouteMap = ({ className, ...props }: Props) => {
  const { isLoaded } = useGoogleMapsLoader();
  const {
    mapCenter,
    googleMapsForwardDirectionsOptions,
    googleMapsBackwardDirectionsOptions,
    handleForwardDirectionsServiceResponse,
    handleBackwardDirectionsServiceResponse,
    forwardTripDirections,
    backwardTripDirections,
  } = useMapHelper();

  if (!isLoaded || !mapCenter) return null;

  return (
    <div {...props} className={cn('w-full h-[715px] rounded-md overflow-hidden', className)}>
      <GoogleMap
        mapContainerStyle={{ width: '100%', height: '100%' }}
        zoom={10}
        options={{ mapId: GOOGLE_MAP_ID, scrollwheel: false, zoomControl: true }}
        center={mapCenter}
      >
        {googleMapsForwardDirectionsOptions && (
          <DirectionsService
            options={googleMapsForwardDirectionsOptions}
            callback={handleForwardDirectionsServiceResponse}
          />
        )}
        {forwardTripDirections && (
          <DirectionsRenderer options={{
            directions: forwardTripDirections,
            polylineOptions: {
              strokeColor: '#ab2884',
              zIndex: 2,
            },
          }} />
        )}
        {googleMapsBackwardDirectionsOptions && (
          <DirectionsService
            options={googleMapsBackwardDirectionsOptions}
            callback={handleBackwardDirectionsServiceResponse}
          />
        )}
        {backwardTripDirections && (
          <DirectionsRenderer options={{
            directions: backwardTripDirections,
            polylineOptions: {
              strokeColor: '#475569',
              zIndex: 1,
            },
          }} />
        )}
      </GoogleMap>
    </div>

  );
};
